import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLang } from '@/libs/util.lang'
import api from '@/api'
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import enUS from 'vxe-table/lib/locale/lang/en-US'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const messages = loadLocaleMessages()

// Vue.prototype.$languages = Object.keys(messages).map(langlage => ({
//   label: messages[langlage]._name,
//   value: langlage
// }))

const i18n = new VueI18n({
  locale: getLang() || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages,
  silentTranslationWarn: true
})

export default i18n

export function loadLanguageAsync({ funcID, curLanguage }) {
  if (funcID && !i18n.getLocaleMessage(curLanguage)[funcID]) {
    return api
      .SYS_LOCALES_PAGE({
        funcID: funcID,
        curLanguage: curLanguage
      })
      .then((res) => {
        const originMessages = i18n.getLocaleMessage(i18n.locale)
        var pageLang = {}
        if (res && res.body) {
          pageLang[funcID] = res.body
        }
        let langs = { ...originMessages, ...pageLang }
        if (i18n.locale === 'cn') {
          langs = { ...langs, ...zhCN }
        } else if (i18n.locale === 'en') {
          langs = { ...langs, ...enUS }
        }
        i18n.setLocaleMessage(i18n.locale, langs)
      })
  }
  return Promise.resolve()
}
